import { useCallback, useEffect, useRef } from 'react';
import { OnChunkCallback } from 'nekst-api';
import {
  attachRelayListener,
  createRelayDispatcher,
  detachRelayListener,
  clearRelay,
} from './streamRelay';

export function useStreamRelay(
  handleChunk: OnChunkCallback,
  resumeFromTransfer: boolean,
) {
  const resumeRef = useRef(resumeFromTransfer);

  useEffect(() => {
    if (!resumeRef.current) {
      return undefined;
    }
    resumeRef.current = false;
    attachRelayListener(handleChunk);
    return () => { detachRelayListener(); };
  }, [handleChunk]);

  const startRelay = useCallback((): OnChunkCallback => {
    const dispatcher = createRelayDispatcher();
    attachRelayListener(handleChunk);
    return dispatcher;
  }, [handleChunk]);

  const stopRelay = useCallback(() => {
    detachRelayListener();
    clearRelay();
  }, []);

  return { startRelay, stopRelay };
}
